/* LUNEVAR: approximate local prices, free-shipping progress, product recommendations. Checkout is charged in USD. */
(function(){
  var TZ={'Asia/Qatar':'QA','Asia/Dubai':'AE','Asia/Riyadh':'SA','Asia/Kuwait':'KW','Asia/Bahrain':'BH','Asia/Muscat':'OM',
    'Europe/London':'GB','Europe/Dublin':'IE','Europe/Paris':'FR','Europe/Berlin':'DE','Europe/Madrid':'ES','Atlantic/Canary':'ES','Europe/Rome':'IT',
    'Europe/Amsterdam':'NL','Europe/Brussels':'BE','Europe/Vienna':'AT','Europe/Lisbon':'PT','Atlantic/Madeira':'PT','Atlantic/Azores':'PT','Europe/Helsinki':'FI',
    'Europe/Stockholm':'SE','Europe/Copenhagen':'DK','Europe/Warsaw':'PL','Europe/Prague':'CZ','Europe/Athens':'GR','Asia/Nicosia':'CY','Asia/Famagusta':'CY',
    'Europe/Malta':'MT','Europe/Luxembourg':'LU','Europe/Bratislava':'SK','Europe/Ljubljana':'SI','Europe/Tallinn':'EE','Europe/Riga':'LV','Europe/Vilnius':'LT',
    'Europe/Zagreb':'HR','Europe/Bucharest':'RO','Europe/Sofia':'BG','Europe/Budapest':'HU','Europe/Zurich':'CH','Europe/Oslo':'NO','Asia/Hong_Kong':'HK',
    'Asia/Jerusalem':'IL','Asia/Tel_Aviv':'IL','Asia/Tokyo':'JP','Asia/Seoul':'KR','Asia/Kuala_Lumpur':'MY','Asia/Kuching':'MY','Asia/Singapore':'SG',
    'Pacific/Auckland':'NZ','America/Toronto':'CA','America/Vancouver':'CA','America/Edmonton':'CA','America/Winnipeg':'CA','America/Halifax':'CA',
    'America/St_Johns':'CA','America/Regina':'CA','America/Moncton':'CA'};
  var CUR={QA:'QAR',AE:'AED',SA:'SAR',KW:'KWD',BH:'BHD',OM:'OMR',GB:'GBP',SE:'SEK',DK:'DKK',PL:'PLN',CZ:'CZK',RO:'RON',HU:'HUF',CH:'CHF',NO:'NOK',
    HK:'HKD',IL:'ILS',JP:'JPY',KR:'KRW',MY:'MYR',SG:'SGD',NZ:'NZD',AU:'AUD',CA:'CAD',US:'USD'};
  ['IE','FR','DE','ES','IT','NL','BE','AT','PT','FI','GR','CY','MT','LU','SK','SI','EE','LV','LT','HR','BG'].forEach(function(c){CUR[c]='EUR';});
  var FREE=['US','GB','CA','AU','AE','AT','BE','CZ','DE','DK','ES','FI','FR','IE','IT','NL','PL','PT','SE'];
  var THRESHOLD=7500;
  function store(k,v){try{if(v===undefined){return localStorage.getItem(k);}localStorage.setItem(k,v);}catch(e){return null;}}
  function country(){
    var tz='';try{tz=Intl.DateTimeFormat().resolvedOptions().timeZone||'';}catch(e){}
    if(TZ[tz])return TZ[tz];
    if(/^Australia\//.test(tz))return 'AU';
    if(/^(America\/(New_York|Chicago|Denver|Los_Angeles|Phoenix|Anchorage|Detroit|Boise|Indiana|Kentucky|North_Dakota|Juneau|Sitka|Nome|Adak|Menominee)|Pacific\/Honolulu)/.test(tz))return 'US';
    var lang=(navigator.language||'').split('-')[1];
    if(lang&&CUR[lang.toUpperCase()])return lang.toUpperCase();
    return (window.LV_COUNTRY||'').toUpperCase()||null;
  }
  var C=country();var CURRENCY=C?CUR[C]:null;
  var rate=null;
  function fmt(cents){
    if(!rate)return '';
    var v=cents/100*rate;var noDec=['JPY','KRW','HUF'].indexOf(CURRENCY)>-1||v>=1000;
    try{return new Intl.NumberFormat(navigator.language||'en',{style:'currency',currency:CURRENCY,maximumFractionDigits:noDec?0:2,minimumFractionDigits:noDec?0:2}).format(v);}catch(e){return CURRENCY+' '+v.toFixed(noDec?0:2);}
  }
  function paintPrices(){
    if(!rate||!CURRENCY||CURRENCY==='USD')return;
    [].forEach.call(document.querySelectorAll('[data-lv-usd]'),function(el){
      var cents=parseInt(el.getAttribute('data-lv-usd'),10);if(isNaN(cents))return;
      var box=el.parentNode.querySelector('.lv-approx[data-for="'+(el.id||'')+'"]')||(el.nextElementSibling&&el.nextElementSibling.classList&&el.nextElementSibling.classList.contains('lv-approx')?el.nextElementSibling:null);
      if(!box){box=document.createElement('span');box.className='lv-approx';el.parentNode.insertBefore(box,el.nextSibling);}
      box.textContent='≈ '+fmt(cents)+' · charged in USD';
    });
  }
  function paintFreeShip(){
    [].forEach.call(document.querySelectorAll('[data-lv-freeship]'),function(el){
      var total=parseInt(el.getAttribute('data-lv-freeship'),10)||0;
      if(!C||FREE.indexOf(C)<0){el.hidden=true;return;}
      el.hidden=false;var left=THRESHOLD-total;var bar=el.querySelector('.lv-freeship__bar span');var txt=el.querySelector('.lv-freeship__text');
      if(bar)bar.style.width=Math.min(100,Math.round(total/THRESHOLD*100))+'%';
      if(txt)txt.textContent=left>0?('You are $'+(left/100).toFixed(2)+' away from free tracked shipping.'):'Free tracked shipping unlocked for your order.';
    });
  }
  function loadRates(){
    if(!CURRENCY||CURRENCY==='USD')return;
    var cached=null;try{cached=JSON.parse(store('lvRates')||'null');}catch(e){}
    if(cached&&cached.t>Date.now()-12*3600e3&&cached.r&&cached.r[CURRENCY]){rate=cached.r[CURRENCY];paintPrices();return;}
    fetch('https://open.er-api.com/v6/latest/USD').then(function(r){return r.json();}).then(function(j){
      if(j&&j.rates&&j.rates[CURRENCY]){rate=j.rates[CURRENCY];store('lvRates',JSON.stringify({t:Date.now(),r:j.rates}));paintPrices();}
    }).catch(function(){});
  }
  function loadRecs(){
    var box=document.querySelector('[data-lv-recs]');if(!box)return;
    var url=box.getAttribute('data-url');
    fetch(url).then(function(r){return r.text();}).then(function(h){
      var d=document.createElement('div');d.innerHTML=h;var inner=d.querySelector('[data-lv-recs-inner]');
      if(inner&&inner.querySelector('.product-card')){box.innerHTML='';box.appendChild(inner);}
    }).catch(function(){});
  }
  window.lvLocal={refresh:function(){paintPrices();paintFreeShip();},country:C,currency:CURRENCY};
  function init(){paintFreeShip();loadRates();loadRecs();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
